import { blogPosts } from "@/data/blogContent";

export interface SearchEntry {
  title: string;
  path: string;
  group: "Products" | "Bath & Sanitary" | "Pages" | "Blog";
  description?: string;
  keywords?: string;
}

const products: SearchEntry[] = [
  { title: "REM7 — Flagship Smart Toilet", path: "/products/rem7", description: "Specification-grade flagship series" },
  { title: "LUXA M80", path: "/products/luxa", description: "Flagship premium smart toilet" },
  { title: "LUNA M9", path: "/products/luna", description: "Wellness & comfort series" },
  { title: "NOVA TEG5", path: "/products/nova", description: "Family-friendly smart toilet" },
  { title: "ARIA H60", path: "/products/aria", description: "Eco-luxury wall-hung" },
  { title: "VENA M80F", path: "/products/vena", description: "Complete bidet experience" },
  { title: "AURELIUS M158", path: "/products/aurelius", description: "Ultimate luxury series" },
  { title: "AURELUX M132", path: "/products/aurelux", description: "Premium wellness series" },
  { title: "LUMA M6", path: "/products/luma", description: "Elegant smart design" },
  { title: "REM7 M3", path: "/products/m3", description: "REM7 variant" },
  { title: "REM7 S1", path: "/products/s1", description: "REM7 variant" },
  { title: "REM7 K2", path: "/products/k2", description: "REM7 variant" },
  { title: "REM7 U1", path: "/products/u1", description: "REM7 variant" },
  { title: "REM7 L1", path: "/products/l1", description: "REM7 variant" },
].map((p) => ({ ...p, group: "Products" as const }));

const bath: SearchEntry[] = [
  { title: "VELA SP1836 Freestanding Bathtub", path: "/bath-sanitary/vela-freestanding" },
  { title: "REM7 Whirlpool", path: "/bath-sanitary/rem7-whirlpool" },
  { title: "REM7 Whirlpool Compact", path: "/bath-sanitary/rem7-whirlpool-compact" },
  { title: "REM7 Whirlpool Deluxe", path: "/bath-sanitary/rem7-whirlpool-deluxe" },
  { title: "REM7 Whirlpool Surf", path: "/bath-sanitary/rem7-whirlpool-surf" },
  { title: "ARIA Diamond Bathtub", path: "/bath-sanitary/aria-diamond" },
  { title: "ARIA Monolith Bathtub", path: "/bath-sanitary/aria-monolith" },
  { title: "ARIA Sculpt Bathtub", path: "/bath-sanitary/aria-sculpt" },
  { title: "VENA Basin", path: "/bath-sanitary/vena-basin" },
  { title: "VENA Vanity", path: "/bath-sanitary/vena-vanity" },
].map((p) => ({ ...p, group: "Bath & Sanitary" as const }));

const pages: SearchEntry[] = [
  { title: "Home", path: "/" },
  { title: "All Smart Toilets", path: "/smart-toilets", description: "Full product collection" },
  { title: "Bath & Sanitary Collection", path: "/bath-sanitary" },
  { title: "Technology", path: "/technology" },
  { title: "About Aureum VII Trading", path: "/about" },
  { title: "Contact", path: "/contact" },
  { title: "B2B & Projects", path: "/business", description: "Architects, developers, hotels" },
  { title: "The Aureum VII Collection", path: "/collection", description: "Image-led overview of all products" },
  { title: "Trade Brochure", path: "/trade-brochure", description: "Collection preview for trade" },
  { title: "Compare Models", path: "/compare" },
  { title: "Sustainability", path: "/sustainability" },
  { title: "FAQ", path: "/faq" },
  { title: "European Markets", path: "/european-markets" },
  { title: "Germany", path: "/markets/germany" },
  { title: "United Kingdom", path: "/markets/uk" },
  { title: "France", path: "/markets/france" },
  { title: "Italy", path: "/markets/italy" },
  { title: "Spain", path: "/markets/spain" },
  { title: "USA (B2B)", path: "/markets/usa" },
  { title: "Blog", path: "/blog" },
  { title: "Privacy Policy", path: "/privacy-policy" },
  { title: "Return Policy", path: "/return-policy" },
  { title: "Shipping Policy", path: "/shipping-policy" },
  { title: "Terms & Conditions", path: "/terms-conditions" },
].map((p) => ({ ...p, group: "Pages" as const }));

const blog: SearchEntry[] = blogPosts.map((post) => ({
  title: post.title,
  path: post.slug,
  group: "Blog" as const,
  description: post.excerpt,
  keywords: [post.category, ...(post.tags || [])].join(" "),
}));

export const searchIndex: SearchEntry[] = [...products, ...bath, ...pages, ...blog];

export const searchSite = (query: string, limit = 30): SearchEntry[] => {
  const q = query.trim().toLowerCase();
  if (!q) return [];
  const terms = q.split(/\s+/);
  return searchIndex
    .map((entry) => {
      const haystack = `${entry.title} ${entry.description ?? ""} ${entry.keywords ?? ""} ${entry.path}`.toLowerCase();
      if (!terms.every((t) => haystack.includes(t))) return null;
      const score = entry.title.toLowerCase().startsWith(q) ? 0 : entry.title.toLowerCase().includes(q) ? 1 : 2;
      return { entry, score };
    })
    .filter((r): r is { entry: SearchEntry; score: number } => r !== null)
    .sort((a, b) => a.score - b.score)
    .slice(0, limit)
    .map((r) => r.entry);
};
